var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenderFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.66699C9.06087 2.66699 10.0783 3.08842 10.8284 3.83857C11.5786 4.58871 12 5.60613 12 6.66699C12 8.64699 10.56 10.2937 8.66667 10.6137V12.0003H10V13.3337H8.66667V14.667H7.33333V13.3337H6V12.0003H7.33333V10.6137C5.44 10.2937 4 8.64699 4 6.66699C4 5.60613 4.42143 4.58871 5.17157 3.83857C5.92172 3.08842 6.93913 2.66699 8 2.66699M8 4.00033C7.29276 4.00033 6.61448 4.28128 6.11438 4.78137C5.61428 5.28147 5.33333 5.95975 5.33333 6.66699C5.33333 7.37424 5.61428 8.05251 6.11438 8.55261C6.61448 9.05271 7.29276 9.33366 8 9.33366C8.70724 9.33366 9.38552 9.05271 9.88562 8.55261C10.3857 8.05251 10.6667 7.37424 10.6667 6.66699C10.6667 5.95975 10.3857 5.28147 9.88562 4.78137C9.38552 4.28128 8.70724 4.00033 8 4.00033Z",
    fill: "#4F46E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderFemale);
export default __webpack_public_path__ + "static/media/genderFemale.a8c1f2f9.svg";
export { ForwardRef as ReactComponent };